import { IAddress } from 'models';
import { GoogleAddress } from 'models/google';

export default (g: Partial<GoogleAddress> | undefined = {}): IAddress => ({
    city: `${g.locality || ''}`.trim(),
    state: `${g.administrative_area_level_1 || ''}`.trim(),
    street_line1: `${g.street || ''}`.trim(),
    zip: `${g.postal_code || ''}`.trim(),
});
